import { SyntheticEvent } from 'react';
import { useAlert } from 'react-alert';
import I18n from 'i18n-js';

// @ts-ignore lib
import { deleteRadarProfile } from '@lootboy/lib/slices/radarUserProfile';

import Alert from '~/components/Alert';
import StyledButton, {
  EStyledButtonVariant,
} from '~/components/atoms/StyledButton';
import BottomSheetDialog from '~/components/molecules/BottomSheetDialog';

import { MENU_DIALOG_CONTAINER_ID } from '~/config';
import { useAppDispatch } from '~/redux/store/useAppDispatch';
import { parseLootBoyError } from '~/utilities/errors';

import styles from './ResetChatRadarDialog.module.scss';

export function ResetChatRadarDialog({
  close,
}: {
  close: () => void;
}): JSX.Element {
  const alert = useAlert();
  const dispatch = useAppDispatch();

  return (
    <BottomSheetDialog
      onClose={close}
      header={I18n.t('MenuView_resetradar_bc')}
      elementIdToAnimate={MENU_DIALOG_CONTAINER_ID}
      renderFooter={({ closeDialog }) => (
        <div className={styles.footerContent}>
          <StyledButton
            className={styles.resetButton}
            onClick={async (event: SyntheticEvent<HTMLButtonElement>) => {
              const { currentTarget: clickedButton } = event;
              try {
                clickedButton.disabled = true;
                await dispatch(deleteRadarProfile());
                alert.success(
                  <Alert title={I18n.t('ResetRadarView_deleted_successful')} />,
                );
                closeDialog();
              } catch (error) {
                const { message } = parseLootBoyError(
                  error,
                  I18n.t('DeleteAccountView_deleted_failed'),
                );
                alert.error(
                  <Alert
                    title={I18n.t('common_error')}
                    body={message}
                  />,
                );
                clickedButton.disabled = false;
              }
            }}
          >
            {I18n.t('MenuView_resetradar_sbutton')}
          </StyledButton>
          <StyledButton
            className={styles.cancelButton}
            variant={EStyledButtonVariant.BLUE}
            onClick={closeDialog}
          >
            {I18n.t('MenuView_resetradar_pbutton')}
          </StyledButton>
        </div>
      )}
    >
      <div className={styles.container}>
        <h1 className={styles.heading}>{I18n.t('common_are_you_sure')}</h1>
        <p className={styles.infoText}> {I18n.t('MenuView_resetradar_sub')}</p>
      </div>
    </BottomSheetDialog>
  );
}
